import React, { useState } from 'react';
import { IconAdvisor, IconChat, IconPhone } from './icons';

const CANALES = ['WhatsApp', 'Llamada'];
export const FRANJAS = [
  ['Hoy', 'hoy en el próximo espacio disponible'],
  ['Mañana 9–11 a. m.', 'mañana entre 9 y 11 a. m.'],
  ['Mañana 2–5 p. m.', 'mañana entre 2 y 5 p. m.'],
];

// «Hablar con un asesor»: canal + franja; funciona en cualquier momento del chat
export const AsesorSheet = ({ usted = false, onConfirm, onVoz, onClose }) => {
  const [canal, setCanal] = useState('WhatsApp');
  const [franja, setFranja] = useState(FRANJAS[1][0]);
  // Correo para la invitación (opcional): se pueden poner varios separados por coma
  const [correo, setCorreo] = useState('');
  const correos = correo.split(/[,;\s]+/).filter(Boolean);
  const correoMalo = correos.some((c) => !/^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i.test(c));
  return (
    <div className="ases-overlay" data-testid="asesor-sheet" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="ases-card" onClick={(e) => e.stopPropagation()}>
        <header className="ases-head">
          <IconAdvisor size={22} color="#2F6B4F" />
          <strong>{usted ? '¿Cómo prefiere que lo contactemos?' : '¿Cómo prefieres que te contactemos?'}</strong>
        </header>
        <div className="ases-grupo">
          {CANALES.map((c) => (
            <button key={c} type="button" className={canal === c ? 'on' : ''} onClick={() => setCanal(c)} data-testid={`asesor-canal-${c.toLowerCase()}`}>
              {c === 'WhatsApp' ? <IconChat size={15} /> : <IconPhone size={15} />} {c}
            </button>
          ))}
        </div>
        <span className="ases-k">¿Cuándo?</span>
        <div className="ases-grupo">
          {FRANJAS.map(([t]) => (
            <button key={t} type="button" className={franja === t ? 'on' : ''} onClick={() => setFranja(t)} data-testid={`asesor-franja-${FRANJAS.findIndex((f) => f[0] === t)}`}>
              {t}
            </button>
          ))}
        </div>
        <label className="ases-k" htmlFor="ases-correo">{usted ? 'Correo para enviarle la invitación (opcional)' : 'Correo para enviarte la invitación (opcional)'}</label>
        <input
          id="ases-correo"
          className="ases-correo"
          type="email"
          inputMode="email"
          placeholder="nombre@correo.com"
          value={correo}
          onChange={(e) => setCorreo(e.target.value)}
          data-testid="asesor-correo"
        />
        {correoMalo ? <span className="pp-aviso" data-testid="asesor-correo-error">Revisa el correo: parece incompleto.</span> : null}
        <span className="ases-nota">Horario de atención: lunes a viernes de 8 a. m. a 6 p. m. y sábados de 8 a. m. a 12 m.</span>
        <button type="button" className="btn-accion ases-ok" disabled={correoMalo} onClick={() => onConfirm(canal, FRANJAS.find((f) => f[0] === franja), correos.join(','))} data-testid="asesor-confirmar">
          Confirmar
        </button>
        {onVoz ? (
          <button type="button" className="btn-ghost ases-voz" onClick={onVoz} data-testid="asesor-voz">
            <IconPhone size={15} /> Hablar ahora por voz
          </button>
        ) : null}
        <button type="button" className="pay-cancelar" onClick={onClose} data-testid="asesor-cancelar">Cancelar</button>
      </div>
    </div>
  );
};
